import { Component, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormRadioField } from './form-radio-button.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-radio-button',
  templateUrl: './form-radio-button.component.html',
  styleUrls: ['./form-radio-button.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormRadioButtonComponent<N = any> extends FormBaseComponent<FormRadioField<N>> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    private cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    this.subscribe = this.service.detectChanges$.subscribe(() => {
      this.cd.detectChanges();
    })
  }
  onComponentDestroy() {}
}
